import {Link} from '@remix-run/react';
import {formatSize} from '~/domains/file-system/utilities/formatSize';

export interface PublicationFileProps {
  file: FileSystem.PublicFileDto;
}

export function PublicationFile({file}: PublicationFileProps) {
  return (
    <Link
      className="px-2 py-2 flex flex-col w-full text-sm hover:bg-shade-3"
      target="_blank"
      to={file.url}
    >
      <div className="flex gap-2">
        <span className="text-primary-12">Download</span>
        <span>{formatSize(file.size)}</span>•<span>{file.extension}</span>
      </div>
    </Link>
  );
}
